import {
    DataGridPro, GridColDef,
    Box, Button, Typography,
    Delete as DeleteIcon, Edit as EditIcon,
    MuiIcons
} from '@leap4/frontend';
import React, { useContext } from 'react';
import { IReport } from "../report.interface";
import { ReportContext } from "../reportContext";

const { PlayArrow: PlayArrowIcon } = MuiIcons;

interface SavedTemplatesProps {
    runReportTemplate: (report: IReport) => void;
    deleteReport: (report: IReport) => void;
    updateReport: (report: IReport) => void;
}

const formatDate = (dateString: string) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB');
};

const SavedTemplates: React.FC<SavedTemplatesProps> = ({ runReportTemplate, deleteReport, updateReport }) => {
    const {
        reportTemplates,
    } = useContext(ReportContext);

    const columns: GridColDef[] = [
        { field: 'name', headerName: 'Template Name', flex: 1 },
        {
            field: 'created',
            headerName: 'Created',
            flex: 1,
            valueFormatter: (params: any) => formatDate(params.value)
        },
        {
            field: 'updated',
            headerName: 'Updated At',
            flex: 1,
            valueFormatter: (params: any) => formatDate(params.value)
        },
        { field: 'createdBy', headerName: 'Created By', flex: 1 },
        { field: 'description', headerName: 'Description', flex: 1 },
        {
            field: 'isRelativePeriod',
            headerName: 'Time Reference',
            flex: 1,
            valueFormatter: (params: any) => params.value ? 'Relative' : 'Fixed'
        },
        {
            field: 'Remove',
            headerName: 'Remove',
            sortable: false,
            width: 100,
            renderCell: (params) => (
                <Button
                    variant="contained"
                    color="error"
                    size="small"
                    onClick={() => deleteReport(params.row)}
                >
                    <DeleteIcon />
                </Button>
            ),
        },
        {
            field: 'Modify',
            headerName: 'Modify',
            sortable: false,
            width: 100,
            renderCell: (params) => (
                <Button
                    variant="contained"
                    color="info"
                    size="small"
                    onClick={() => updateReport(params.row)}
                >
                    <EditIcon />
                </Button>
            ),
        },
        {
            field: 'Run',
            headerName: 'Run',
            sortable: false,
            width: 100,
            renderCell: (params) => (
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => runReportTemplate(params.row)}
                >
                    <PlayArrowIcon />
                </Button>
            ),
        },
    ];

    return (
        <Box p={2}>
            <Typography variant="h6" gutterBottom>Saved Templates</Typography>
            <Box sx={{ height: 500, width: '100%' }}>
                <DataGridPro
                    rows={reportTemplates}
                    columns={columns as any}
                    getRowId={(row) => row._id || row.name}
                    pageSizeOptions={[10, 25, 50]}
                    initialState={{
                        pagination: { paginationModel: { pageSize: 10 } }
                    }}
                />
            </Box>
        </Box>
    );
};

export default SavedTemplates;
